import React, { Component, Fragment } from 'react'
import { Field, reduxForm, change, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import Spinner from '../spinner'
import { ButtonContained } from '../app-button/button'
import SelectWithClear from './field/selectWithClear'
import InputOutlined from './field/inputOutlined'
import { maxLength } from './validation/validation'
import MenuItem from '@material-ui/core/MenuItem'

const styles = theme => ({
  form: {
    width: '100%',
  },
  fieldRow: {
    position: 'relative',
  },
  selectWrapper: {
    maxWidth: 340,
  },
  inputBox: {
    width: '100%',
    maxWidth: 340,
  },
  titleFieldGroup: {
    fontSize: '14px',
    marginBottom: '16px',
  },
  fieldGroupe: {
    position: 'relative',
    marginBottom: '20px',
    paddingBottom: 10,
  },
  fieldContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  btnDeleteField: {
    right: 0,
    bottom: '-7px',
    position: 'absolute',
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    outline: 'none',
    borderBottom: '1px dashed #ff2d55',
    padding: 0,
    color: '#ff2d55',
    '&:hover': {
      border: 0,
    },
  },
  btnAddField: {
    color: '#fff',
    bottom: 10,
    cursor: 'pointer',
    position: 'absolute',
    backgroundColor: '#8866ff',
    border: 0,
    borderRadius: 2,
    padding: '5px 10px',
    outline: 'none',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1)',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: 'rgb(95, 71, 178)',
    },
  },
})

class ReportSettingsForm extends Component {
  state = {
    fieldGroupes: this.props.data.groupedReportGoals,
    counter: 0,
    isConfigurate: window.state.isReportConfigurated,
  }

  resetValueField = name => {
    this.props.change(this.props.form, name, null)
  }

  handleAddField = type => {
    const newFieldGroupes = this.state.fieldGroupes.filter(
      groupe => groupe.type === type
    )

    newFieldGroupes[0].goals.push({})

    this.handleCount()

    this.setState(({ fieldGroupes }) => {
      return {
        fieldGroupes,
        ...newFieldGroupes,
      }
    })
  }

  handleCount = () => {
    let counter = 0

    this.state.fieldGroupes.forEach(({ goals }) =>
      goals.forEach(() => (counter += 1))
    )

    this.setState({
      counter,
    })
  }

  handleDeleteField = (type, index) => {
    const updateFieldGroupes = this.state.fieldGroupes.filter(
      groupe => groupe.type === type
    )

    delete updateFieldGroupes[0].goals[index]

    this.handleCount()

    this.setState(({ fieldGroupes }) => {
      return {
        fieldGroupes,
        ...updateFieldGroupes,
      }
    })

    this.resetValueField(`goals[${type}][${index}][id]`)
  }

  componentDidMount() {
    this.handleCount()

    this.setState(({ fieldGroupes }) => {
      return {
        fieldGroupes,
      }
    })
  }

  render() {
    const { classes, handleSubmit, isFetching, data, values } = this.props
    const { fieldGroupes, counter } = this.state
    const { availableGoals, maxGoalsTotalCount } = data

    const fieldOptions = (type, index) => {
      let selectedItems = []

      const goals = availableGoals.filter(goals => {
        if (type === 'order') {
          return goals
        } else {
          return goals.id !== 'ecom'
        }
      })

      if (values) {
        const items =
          this.props.values && Object.values(this.props.values.goals)

        const flattenDeep = arr => {
          return arr.reduce(
            (acc, val) =>
              Array.isArray(val)
                ? acc.concat(flattenDeep(val))
                : acc.concat(val),
            []
          )
        }
        const flattenItems = flattenDeep(items)
        selectedItems = flattenItems.map(({ id }) => id)
      }

      if (values && values.goals[type] && values.goals[type][index]) {
        return goals
          .filter(goal => {
            if (
              selectedItems.indexOf(goal.id) !== -1 &&
              values.goals[type][index].id != goal.id
            ) {
              return false
            }
            return true
          })
          .map(goal => {
            return (
              <MenuItem value={goal.id} key={goal.id}>
                {goal.name} (ID: {goal.id})
              </MenuItem>
            )
          })
      }

      return goals
        .filter(goal => {
          if (selectedItems.indexOf(goal.id) !== -1) {
            return false
          }
          return true
        })
        .map(goal => {
          return (
            <MenuItem value={goal.id} key={goal.id}>
              {goal.name} (ID: {goal.id})
            </MenuItem>
          )
        })
    }

    const placeholderInputText = type => {
      switch (type) {
        case 'lead':
          return 'Заявка это ...'
        case 'call':
          return 'Звонок это ...'
        case 'order':
          return 'Продажа это ...'
        default:
          return null
      }
    }

    const placeholderSelectText = type => {
      switch (type) {
        case 'lead':
          return 'Название заявки'
        case 'call':
          return 'Название звонка'
        case 'order':
          return 'Название продажи'
        default:
          return null
      }
    }

    const fieldGroupeTitle = type => {
      switch (type) {
        case 'lead':
          return 'Укажите, какие цели из Google Analytics считать “Заявкой”:'
        case 'call':
          return 'Укажите, какие цели из Google Analytics считать “Звонком”:'
        case 'order':
          return 'Укажите, какие цели из Google Analytics считать “Продажей”:'
        default:
          return null
      }
    }

    const title = type => (
      <div className={classes.titleFieldGroup}>{fieldGroupeTitle(type)}</div>
    )

    const fieldRow = (type, index) => {
      return (
        <div className={classes.fieldRow} key={index}>
          <div className={classes.fieldContainer}>
            <div className={classes.selectWrapper}>
              <Field
                name={`goals[${type}][${index}][id]`}
                component={SelectWithClear}
                handleResetField={this.resetValueField}
              >
                <MenuItem value="" style={{ display: 'none' }}>
                  <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                    {placeholderInputText(type)}
                  </span>
                </MenuItem>
                {fieldOptions(type, index)}
              </Field>
            </div>
            <div className={classes.inputBox}>
              <Field
                name={`goals[${type}][${index}][custom_name]`}
                label={placeholderSelectText(type)}
                component={InputOutlined}
                type="text"
                handleResetField={this.resetValueField}
                validate={[maxLength]}
                errorStyle="normal"
              />
            </div>
          </div>
          {index !== 0 && (
            <button
              className={classes.btnDeleteField}
              onClick={() => this.handleDeleteField(type, index)}
              type="button"
            >
              Удалить поле
            </button>
          )}
        </div>
      )
    }

    const fields = (type, goals) => {
      return goals.map((goal, index) => fieldRow(type, index))
    }

    const addButton = (goals, type, maxCount) => {
      if (
        counter < maxGoalsTotalCount &&
        counter < availableGoals.length &&
        (goals.length < maxCount || !maxCount)
      ) {
        return (
          <button
            className={classes.btnAddField}
            onClick={() => this.handleAddField(type)}
            type="button"
          >
            Добавить поле
          </button>
        )
      }
    }

    const fieldGroupe = (type, maxCount, goals) => (
      <div className={classes.fieldGroupe} key={type}>
        {title(type)}
        {fields(type, goals)}
        {addButton(goals, type, maxCount)}
      </div>
    )

    return (
      <Fragment>
        <form
          onSubmit={handleSubmit}
          className={cx(classes.form)}
          ref={form => (this.form = form)}
        >
          <div className={classes.titleFieldGroup}>
            Для настройки дашборда мы рекомендуем:
            <ol style={{ padding: '0 0 0 15px' }}>
              <li>
                Настроить цели на заявки с сайта в вашем Google Analytics. В
                дашборде можно указать до трех разный целей для заявок.
              </li>
              <li>
                Подключить коллтрекинг и указать до двух целей для отслеживания
                звонков.
              </li>
              <li>
                Подключить CRM систему и указать либо цель «Успешные продажи»,
                либо событие электронной торговли «Транзакции» в качестве
                «Продажи» в дашборде ROMI center.
              </li>
            </ol>
          </div>

          {fieldGroupes.map(({ type, maxCount, goals }) =>
            fieldGroupe(type, maxCount, goals)
          )}

          <ButtonContained
            style={{
              height: 46,
              fontSize: 16,
              width: '100%',
              padding: 0,
              fontWeight: 600,
            }}
            type="submit"
            color="secondary"
            text={isFetching ? <Spinner stroke="#ffffff" /> : 'Сохранить'}
          />
        </form>
      </Fragment>
    )
  }
}

const mapDispatchToProps = {
  change,
}

const mapStateToProps = (state, props) => {
  return {
    values: getFormValues('ReportSettingsForm')(state),
  }
}

ReportSettingsForm = reduxForm({
  form: 'ReportSettingsForm',
  // enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(ReportSettingsForm))

export default withStyles(styles)(ReportSettingsForm)
